import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { StateService } from '../../core/state/old/state.service';
import { ActiveService } from '../../core/providers/active/active.service';
import { SavedVehicle } from '../../graphql/generated/generated-types';
import { SelectedModificationService } from '../services/selected-modification.service';


export function reloadCurrentComponent(router: Router, stateService: StateService, location: Location): void {
  const currentPathWithoutQueryParams = location.path().split('?')[0]; // path without query
  const originalUrl = location.path(); // full URL with query if needed
  console.log('Current URL:', currentPathWithoutQueryParams);
  if (currentPathWithoutQueryParams === '') { 
    console.log('Reloading current component with redirect to /parts-catalog - 1');
    router.navigateByUrl('/parts-catalog', { skipLocationChange: true })
      .then(() => {
        router.navigateByUrl(originalUrl); 
      });
  
  } else {
    console.log('Reloading current component with redirect to / - 2');
    router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      router.navigateByUrl(originalUrl); 
    });
  
  }

}


export function reloadCurrentComponentAddingNewModificationId(
  router: Router,
  location: Location,
  selectedModificationService: SelectedModificationService,
  activeVehicle: SavedVehicle
): void {
  const fullPath = location.path(); // e.g. "/parts-catalog?brand=toyota&year=2022"
  const currentPath = fullPath.split('?')[0]; // e.g. "/parts-catalog"
  const queryString = fullPath.split('?')[1];

  // Convert query string into object
  const existingQueryParams = queryString
    ? Object.fromEntries(new URLSearchParams(queryString))
    : {};

  // Add or overwrite modificationId
  existingQueryParams['modificationId'] = String(activeVehicle.modificationId);

  // Temporary navigation to force reload
  const dummyPath = currentPath === '' ? '/parts-catalog' : '/';
  selectedModificationService.setModificationId(activeVehicle.modificationId);
  router.navigateByUrl(dummyPath, { skipLocationChange: true }).then(() => {
    router.navigate([currentPath], {
      queryParams: existingQueryParams
    });
  });
}




export function reloadCurrentComponentOld(router: Router, stateService: StateService, location: Location): void {
  const currentPathWithoutQueryParams = location.path().split('?')[0]; // path without query
  const originalUrl = location.path(); // full URL with query if needed
  console.log('Current URL:', currentPathWithoutQueryParams);
  if (currentPathWithoutQueryParams === '') { 
    console.log('Reloading current component... 11111111111');
   if (typeof window !== 'undefined') {
    //window.location.href = originalUrl;
    window.location.reload()
  } else {
    router.navigateByUrl('/parts-catalog', { skipLocationChange: true })
      .then(() => {
        router.navigateByUrl(originalUrl); 
      });
  }
  } else {
    console.log('Reloading current component... 22222222');

  if (typeof window !== 'undefined') {
   // window.location.href = originalUrl;
   window.location.reload()
  } else {
    router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      router.navigateByUrl(originalUrl); 
    });
  }
  }

}
